<script>
  import FormDadosInscricaoPessoa from './FormDadosInscricaoPF.vue';
  import FormDadosInscricaoEstrangeiro from './FormDadosInscricaoEstrangeiro.vue';
  import formatarData from '~js/formatar-data';

  export default {
    components: { FormDadosInscricaoPessoa, FormDadosInscricaoEstrangeiro },
    props: {
      inscricao: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      mostrarMensagemPago() {
        if (!this.inscricao.lancamentoInscricoes)
          return false;

        if (!this.inscricao.lancamentoInscricoes[0].lancamento)
          return false;

        if (!this.inscricao.lancamentoInscricoes[0].lancamento.data)
          return false;

        if (this.inscricao.lancamentoInscricoes[0].lancamento.data > 0) {
          return true;
        }
        else
          return false;
      },
      retornaData(data) {
        if (!data)
          return '';

        return formatarData.paraData(data);
      },
    }
  }
</script>

<template>
  <div>
    <form-dados-inscricao-pessoa :inscricao="inscricao"
                                 v-if="inscricao.tipo != 3"
                                 ref="formDadosInscricaoPessoa">
    </form-dados-inscricao-pessoa>

    <form-dados-inscricao-estrangeiro :inscricao="inscricao"
                                      v-if="inscricao.tipo == 3"
                                      ref="formDadosInscricaoEstrangeiro">
    </form-dados-inscricao-estrangeiro>

    <div v-if="mostrarMensagemPago()" id="mensagemPagamentoPago">
      <div class="hr-line-dashed margin-top-20"></div>

      <p class="PagamentoAlerta">
        <i class="fa fa-check-circle" style="color:green;"></i>
        <span style="font-size: 16px;margin-left: 10px;">Pagamento recebido com sucesso no dia {{ retornaData(this.inscricao.lancamentoInscricoes[0].lancamento.data) }}</span>
      </p>
    </div>

    <div v-if="inscricao.questionarios.length > 0">
      <div class="hr-line-dashed margin-top-20"></div>

      <span class="font-bold">Questionário:</span>

      <div style="padding-top: 20px;"></div>

      <div v-for="(questionario, index) in inscricao.questionarios">
        <div class="row">
          <dl class="col-xs-12">
            <dt>{{index + 1}} - {{questionario.pergunta}}</dt>
          </dl>
        </div>

        <div class="row">
          <dl class="col-xs-12" v-if="questionario.tipoResposta == 1">
            <dd>{{ questionario.selecionado == true ? 'Sim' : 'Não' }}</dd>
          </dl>

          <dl class="col-xs-12" v-if="questionario.tipoResposta == 2 | questionario.tipoResposta == 3">
            <dd>{{ questionario.campoResposta }}</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-matricular/componentes/compartilhado/FormDadosInscricao.vue